<script>

import axios from 'axios'

export default {
  props: {
    source: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: "N/A"
    },
    wclass: {
      type: String,
      default: ""
    },
    trend: {
      type: Boolean,
      default: false
    },
    start: {
      type: Number,
      default: 0
    },
    end: {
      type: Number,
      default: 0
    },
    range: {
			type: Boolean,
			default: false
    },
    format: {
			type: String,
			default: '0.0a'
    },
  },
  data: function () {
    return {
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      refresh: 60000,
      value: 0,
      oldValue: 0,
      isBusy: true
    }
  },
  methods: {
    // numeralFormat: function (number) {
    //   return (Math.round(number * 100) / 100).toLocaleString()
    // },
    getData: function () {
      let that = this;
      if (that.show_last_modification){
        that.padding_top= '0px';
      }
      if (that.source === undefined) {
        console.error('vIndicator Error - Source file not defined in component.');
        return
      }
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      let source = that.source
      if (that.range) {
        if (that.start > 0) source = source + '&start=' + that.start.toString()
        if (that.end > 0) source = source + '&end=' + that.end.toString()
      }
      axios
      .get(baseURL + source)
      .then(function (response) {
          if (response.status === 200) {
            if (response.data.value !== undefined && response.data.oldValue !== undefined) {
              that.value = response.data.value
              that.oldValue = response.data.oldValue
            }
            if (response.data.data !== undefined) {
              that.data = response.data.data
              if (that.data.length>1) {
                that.value = that.data[0].count
                that.oldValue = that.data[1].count
              }
            }
            that.lastUpdated = new Date(response.data.updated).toLocaleString()
            that.isBusy = false
          }
          else if (response.status === 404) {
            console.error('vIndicator Error - Source file not found.');
            return
          }
      })
			.catch(function (error) {
          console.error('Error loading vIndicator data. Error:', error.response);
				if (error.response.status === 401 || error.response.status === 403) {
					localStorage.removeItem('idToken')
					that.$router.push({ name: 'Home' })
				}
			})
    }
  },
  created: function() {
    this.getData()
  }
}
</script>

<template>
  <table width="100%" border="0px">
      <tr>
          <template v-if="trend==true">
            <td style="text-align: right !important;width:20px;">
              <template v-if="value>oldValue">
                <span>
                  <feather type="arrow-up-circle" class="icon-xs" />
                </span>
              </template>
              <template v-else-if="value<oldValue">
                <span>
                  <feather type="arrow-down-circle" class="icon-xs" />
                </span>
              </template>
            </td>
          </template>
          <td style="text-align: right !important;">
            <span class="big_number" :class="wclass">
                <template v-if="value>0">
                  {{ value | numeralFormat(format)}}
                </template>
                <template v-else>
                  ?
                </template>
            </span>
          </td>
          <td style="text-align: left !important;width:80px;">
            <div class="legend">
              {{ title }}
            </div>
          </td>
      </tr>
  </table>
</template>

<style>
  .big_number {
    font-size: 3em;
    font-weight: 500;
  }
  .legend {
    text-transform: uppercase;
    line-height: 1em;
    font-size: 0.8em;
  }

</style>
